<template>
  <div style="padding: 0 15%">
    <el-image
      class="cursorPointer"
      style="width: 80px; height: 80px; position: absolute; left: 3px; top: 3px"
      @click="showActive = !showActive"
      :src="showActive == true ? code : computer"
      fit="cover"
    />
    <h2>欢迎登录</h2>
    <div style="min-height: 224px">
      <el-form
        v-if="showActive"
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="0"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
      >
        <el-form-item prop="username">
          <el-input
            v-model="ruleForm.username"
            size="large"
            placeholder="手机号/邮箱/学号"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="ruleForm.password"
            size="large"
            type="password"
            show-password
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item prop="code">
          <el-row style="width: 100%">
            <el-col :span="14">
              <el-input
                v-model="ruleForm.code"
                size="large"
                placeholder="验证码"
              />
            </el-col>
            <el-col :span="9" :offset="1">
              <img style="width: 100%; height: 40px" :src="codeImg" alt="验证码" @click="getImg"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            style="width: 100%"
            background-color="#E65833"
            @click="submitForm(ruleFormRef)"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <div v-else class="displayFlex justifyContentCenter">
        <div class="column displayFlex justifyContentCenter">
          <el-image style="width: 190px" :src="loginCode" fit="cover" />
          <p>打开 <span class="OrangeColor">手机微信</span> 扫描二维码登录</p>
        </div>
      </div>
    </div>
    <footer class="displayFlex justifyContentSpaceBetween">
      <p>
        还不是会员,<span
          class="underLine OrangeColor cursorPointer"
          @click="registerVisible"
          >立即注册</span
        >
      </p>
      <p class="cursorPointer" @click="showReset">忘记密码?</p>
    </footer>
  </div>
</template>

<script setup>
import register from "@views/login/register";
import ResetPassword from "@views/login/ResetPassword";
import { reactive, ref, shallowRef, onMounted, getCurrentInstance } from "vue";
import loginCode from "@images/loginCode.jpg";
import code from "@images/code.png";
import computer from "@images/computer.png";
import useLogin from "@/stores/login";
import { ElMessage } from "element-plus";
import {captchaImage, userLogin, getInfo, loginCredit} from "@/request/api/login";
import async from "async";
import IdentityBinding from "@/views/login/IdentityBinding.vue";
import {useRouter} from "vue-router";
import useSiteInformation from "@/stores/siteInformation"

const { proxy } = getCurrentInstance();
const loginStore = useLogin();

const siteInformation = useSiteInformation()
const showActive = ref(true);
const formSize = ref("default");
const ruleFormRef = ref();
const ruleForm = reactive({
  // 手机号/邮箱/学号
  username: "",
  // 密码
  password: "",
  // 验证码
  code: "",
  //验证码id
  uuid: "",
});
const codeImg = ref();
const rules = reactive({
  username: [
    { required: true, message: "请输入账号", trigger: "blur" },
    // { min: 3, max: 5, message: "Length should be 3 to 5", trigger: "blur" },
  ],
  password: [{ required: true, message: "请输入密码", trigger: "blur" }],
  code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
});
const router = useRouter();
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log("submit!");
      const loading = proxy.$loading();
      userLogin(ruleForm).then((res) => {
        if (res.status == 10000) {
          ElMessage({
            message: "登录成功",
            type: "success",
          });

          //记录登录积分
          loginCredit().then(res=>{});

          loginStore.token = res.data.token;
          getInfo().then((res) => {
            loginStore.username = res.data.userInfo.username;
            loginStore.roleId = res.data.userInfo.roleId;
            loginStore.isLogin = true;
            loginStore.showVisible = false;
            loginStore.userId = res.data.userInfo.id;
            loginStore.code = res.data.userInfo.agencyCode;
            loginStore.agencyId = res.data.userInfo.agencyId;
            loginStore.headImg = res.data.userInfo.smallAvatar;
            if(loginStore.headImg == null || loginStore.headImg == ""){
              loginStore.headImg = "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            }
            loading.close();
            router.go(0);
            if(loginStore.agencyId == undefined && loginStore.isLogin){
              loginStore.showVisible = true;
              loginStore.component = shallowRef(IdentityBinding);
            }
            if(res.data.agencySiteInfo != null){
              siteInformation.themeColor = res.data.agencySiteInfo.themeColor
              siteInformation.siteName = res.data.agencySiteInfo.siteName
              siteInformation.versionNumber = res.data.agencySiteInfo.versionNumber
              siteInformation.recordNumber = res.data.agencySiteInfo.recordNumber
              siteInformation.companyPhone = res.data.agencySiteInfo.companyPhone
              siteInformation.companyEmail = res.data.agencySiteInfo.companyEmail
              siteInformation.companyAddress = res.data.agencySiteInfo.companyAddress
              siteInformation.companyWebsite = res.data.agencySiteInfo.companyWebsite
              siteInformation.copyrightInformation = res.data.agencySiteInfo.copyrightInformation
              siteInformation.topBarBackgroundColor = res.data.agencySiteInfo.topBarBackgroundColor
              siteInformation.logo = res.data.agencySiteInfo.logo
              siteInformation.onlineDuration = res.data.agencySiteInfo.onlineDuration
            }

            localStorage.setItem("agencySiteInfo",JSON.stringify(res.data.agencySiteInfo));
          });
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
          loading.close();
          getImg()
        }
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

const resetForm = (formEl) => {
  if (!formEl) return;
  formEl.resetFields();
};
const registerVisible = () => {
  loginStore.component = shallowRef(register);
};
const showReset = () => {
  loginStore.component = shallowRef(ResetPassword);
};
const getImg = async() =>{
  let res = await captchaImage();
  ruleForm.uuid = res.data.uuid;
  codeImg.value = "data:image/gif;base64," + res.data.img;
}


onMounted(() => {
  getImg()
});
</script>

<style lang="scss" scoped>
@import "@/styles/elementButton.scss";
@import "@/styles/common.scss";
@import "@/styles/variables.scss";
h2 {
  margin: 0 0 30px 0;
  text-align: center;
  color: #000;
}
.el-form-item {
  margin-bottom: 24px;
}
.column {
  flex-direction: column;
}
:deep(.el-dialog__body) {
  padding: 0 25%;
}
</style>
